import { SAMSUNG_PAY } from '../components/payment/paymentMethodTypes';
import {formatPhoneNumberUS} from "../components/address/addressFieldFormatters";


export const currencyMinorUnits = {
    BHD: 3,
    BYR: 0,
    XOF: 0,
    BIF: 0,
    XAF: 0,
    CLF: 4,
    CLP: 0,
    KMF: 0,
    DJF: 0,
    XPF: 0,
    GNF: 0,
    ISK: 0,
    IQD: 3,
    JPY: 0,
    JOD: 3,
    KRW: 0,
    KWD: 3,
    LYD: 3,
    OMR: 3,
    PYG: 0,
    RWF: 0,
    TND: 3,
    UGX: 0,
    UYI: 0,
    VUV: 0,
    VND: 0
};

export const currencyFixedScale = currency =>
    
    

    
    
    
    currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;

export const getDenomination = (amount, currencyCode) => parseFloat(amount).toFixed(currencyFixedScale(currencyCode));

export const serializeGiftCardBase = giftCard => ({
    lineItem: giftCard.id,
    message: giftCard.message,
    quantity: giftCard.quantity,
    selfBuy: giftCard.isSelfBuy,
    brandCode: giftCard.brandCode,
    productName: giftCard.product.name, 
    productDescription: giftCard.product.brandName, 
    faceplateCode: giftCard.faceplateCode,
    currencyCode: giftCard.currencyCode || 'USD',
    faceValue: getDenomination(giftCard.amount, giftCard.currencyCode || 'USD'),
    loyaltyMultiplier: giftCard.product.loyalty_multiplier,
    fees: giftCard.product.fees,
    universalProductCode: giftCard.product.universalProductCode
});

export const serializeGiftCardDigital = (giftCard, payment) => ({
    ...serializeGiftCardBase(giftCard),
    recipientEmail: giftCard.isSelfBuy ? payment.email : giftCard.recipientEmail,
    senderName: giftCard.isSelfBuy ? payment.fullName : giftCard.senderName,
    deliveryDate: giftCard.isSelfBuy
        ? new Date().toISOString()
        : new Date(giftCard.deliveryDate).toISOString(),
    recipientName: giftCard.isSelfBuy ? `${payment.firstName} ${payment.lastName}` : giftCard.recipientName
});

export const serializeGiftCardPhysical = giftCard => ({
    ...serializeGiftCardBase(giftCard),
    notifyRecipient: giftCard.expectAGift,
    senderName: giftCard.isSelfBuy ? giftCard.shippingGroup.toAddress.fullName : giftCard.senderName,
    recipientName: giftCard.shippingGroup.toAddress.fullName,
    recipientEmail: giftCard.expectAGift ? giftCard.recipientEmail : undefined
});

export const getOrderEgiftCards = (giftCards, payment) =>
    giftCards
        .filter(giftCard => giftCard.deliveryMethod === 'DIGITAL')
        .map(giftCard => serializeGiftCardDigital(giftCard, payment));

export const getPromoEgiftCards = (giftCards) =>
    giftCards
        .filter(giftCard => giftCard.deliveryMethod === 'DIGITAL')
        .map(giftCard => serializeGiftCardDigital(giftCard, {firstName: 'self', lastName: 'buy', fullName: 'self buy', email: 'self@buy.com'}));

export const serializeShippingAddress = giftCard => ({
    city: giftCard.shippingGroup.toAddress.city,
    street: `${giftCard.shippingGroup.toAddress.street1} ${giftCard.shippingGroup.toAddress.street2}`,
    state: giftCard.shippingGroup.toAddress.state,
    zipCode: giftCard.shippingGroup.toAddress.postalCode,
    countryCode: 'US',
    fullName: giftCard.shippingGroup.toAddress.fullName
});

export const getShippingGroups = giftCards =>
    giftCards
        .filter(giftCard => giftCard.deliveryMethod === 'PHYSICAL')
        .map(giftCard => ({
            shippingAddress: serializeShippingAddress(giftCard),
            certs: [serializeGiftCardPhysical(giftCard)],
            shippingAmount: giftCard.shippingGroup.shippingMethod.shippingAmount,
            shippingMethodToken: giftCard.shippingGroup.shippingMethodToken
        }));

export const serializeCreditCardPayment = payment => ({
    currencyCode: payment.currencyCode,
    creditCardType: payment.creditCardType,
    creditCardNumber: payment.creditCard,
    securityCode: payment.securityCode,
    expirationMonth: payment.expMonth,
    expirationYear: payment.expYear,
    purchaserFirstName: payment.firstName,
    purchaserLastName: payment.lastName,
    phone: payment.phoneNumber,
    purchaserEmail: payment.email,
    street: payment.street1,
    street2: payment.street2,
    city: payment.city,
    state: payment.state,
    zipCode: payment.postalCode,
    countryCode: payment.countryCode || 'US',
    saveStoredPayment: payment.savePayment
});

export const serializeSapPayment = payment => ({
    currencyCode: payment.currencyCode,
    countryCode: payment.countryCode || 'US'
});

export const serializeStoredPayment = payment => ({
    storedPaymentUuid: payment.storedPaymentUuid,
    securityCode: payment.securityCode,
});

export const serializeOrderRequest = ({ payment, cards, totalCost, promoDiscounts={} }) => {
    const serializedOrder = {
        amount: getDenomination(totalCost, payment.currencyCode),
        totalDiscountRewardAmount: promoDiscounts.totalDiscountRewardAmount,
        promoCodes: promoDiscounts.promoCodes,
        paymentMethod: payment.paymentMethod,
        egiftCards: getOrderEgiftCards(cards, payment),
        shippingGroups: getShippingGroups(cards)
    };
    if (payment.paymentMethod === 'storedPayment') {
        serializedOrder.paymentMethod = 'creditCard';
        serializedOrder.storedPayment = serializeStoredPayment(payment);
    }
    if (payment.paymentMethod === 'creditCard') {
        serializedOrder.creditCard = serializeCreditCardPayment(payment);
    }
    if (payment.paymentMethod === 'sap') {
        serializedOrder.sap = serializeSapPayment(payment);
    }
    if (payment.paymentMethod === SAMSUNG_PAY) {
        serializedOrder.samsungPay = {
            token: btoa(JSON.stringify(payment.paymentResponse))
        };

        const paymentInfo = payment.paymentResponse.details.paymentInfo;
        serializedOrder.purchaserFirstName = payment.firstName;
        serializedOrder.purchaserLastName = payment.lastName;

        serializedOrder.purchaserEmail = payment.email;
        serializedOrder.currencyCode = payment.currencyCode;
        serializedOrder.countryCode = 'US'; 

        serializedOrder.street = paymentInfo.billingAddress.addressLine.length > 0 ? paymentInfo.billingAddress.addressLine[0] : "";
        serializedOrder.street2 = paymentInfo.billingAddress.addressLine.length > 1 ? paymentInfo.billingAddress.addressLine[1] : "";
        serializedOrder.city = paymentInfo.billingAddress.city;
        serializedOrder.state = paymentInfo.billingAddress.region;
        serializedOrder.zipCode = paymentInfo.billingAddress.postalCode;
        serializedOrder.phone = formatPhoneNumberUS(payment.paymentResponse.payerPhone);
        serializedOrder.creditCardLast4 = paymentInfo.card_last4digits;
        
        
        
        
        serializedOrder.creditCardType = paymentInfo.cardBrand;
    }
    return serializedOrder;
};

export const sanitizePaymentData = payment => {
    if (payment.creditCard)
        return {
            ccLastFour: payment.creditCard.slice(-4),
            purchaserEmail: payment.email
        };
    return payment;
};

export const serializePromoRequest = (lineItems, amount) => {
    const promos = lineItems.map(val => val.product && val.product.promo).filter(val => val);
    return {
        amount,
        promoCodes: promos.map(promo => promo.promoCode).filter(
            ((value, index, self) => self.indexOf(value) === index)
        ),
        egiftCards: getPromoEgiftCards(lineItems),
        shippingGroups: getShippingGroups(lineItems).map(shipping => {
            if (shipping.shippingMethodToken === '' || typeof shipping.shippingMethodToken === 'undefined') {
                shipping.shippingMethodToken = 'fake';
            }
            return shipping;
        }),
    }
}
